module.exports = __webpack_public_path__ + "img/registration-2000.12267904.png";